import sendRoutes from "./quotations.send"
import uploadRoutes from "./quotations.upload"

export default [
  ...uploadRoutes,
  ...sendRoutes

]
